import type { CampaignHook } from "@/campaigns";
import { PrizeText } from "@/components/prize-text";
import { cn } from "@/lib/utils";

/**
 * The card's hook at row size: the small uppercase label ("TOP PRIZE") and, right after it, the
 * prize in the prize signature (gold, its mark, gliding rather than truncating). The same words
 * the desktop home card leads with, on the in-game switcher's bar and rows.
 */
export const CampaignHookLine = ({
  hook,
  className,
}: {
  hook: CampaignHook;
  className?: string;
}) => (
  // Label then prize, flowing from the left as one phrase ("TOP PRIZE €25,000"): the eye reads
  // the row left to right and never has to bridge a gap to find the value. One line always: a
  // long prize glides (PrizeText marquee) rather than breaking the row. Centre-aligned, not
  // baseline: the prize's marquee wrapper carries a zero-height measuring block that throws
  // baseline alignment off.
  <span
    className={cn("flex min-w-0 items-center justify-start gap-2", className)}
  >
    <span className="shrink-0 font-heading text-[10px] leading-4 font-semibold tracking-wider text-muted-foreground uppercase">
      {hook.label}
    </span>
    <PrizeText
      size="small"
      weight="bold"
      icon
      currencyMark={!hook.isCatalogItem}
      fit="marquee"
      className="min-w-0 text-left"
    >
      {hook.value}
    </PrizeText>
  </span>
);
